window.initGlobalCalendarUI = () => {

  const calHeader = document.querySelector('.ef-header');
  const calNavWrapper = document.querySelector(".ef-global-calendar__nav-wrapper");
  const calNav = document.querySelector(".ef-global-calendar__nav");

  if (calNav !== null) {
    
    window.addEventListener("scroll", () => {
      let calNavRect = calNavWrapper.getBoundingClientRect();

      if (calNavRect.top < 0) {
        calNav.classList.add("--is-sticky");
      } else {
        calNav.classList.remove("--is-sticky");
      }

      if (calHeader.classList.contains('--scroll-up')) {
        calNav.classList.add('--header-visible');
      } else {
        calNav.classList.remove('--header-visible');
      }
    });

    // const ef_calendarFilters = () => {
    //   const ef_calendarFilterButton = document.querySelector(".ef-global-calendar__filter-button");
    //   const ef_calendarFilterButtonArrow = document.querySelector(".ef-global-calendar__filter-button .ef-button__label--more-bottom");
    //   const ef_calendarFilterMenu = document.querySelector(".ef-global-calendar .ef-submenu--filters");

    //   if (ef_calendarFilterButton && ef_calendarFilterMenu) {
    //     ef_calendarFilterButton.addEventListener("click", () => {
    //       ef_calendarFilterButton.classList.toggle("--is-active");
    //       ef_calendarFilterButtonArrow.classList.toggle("--is-active");
    //       ef_calendarFilterMenu.classList.toggle("--is-active");
    //     });
    //   }
    // };

    // ef_calendarFilters();
  }
}

initGlobalCalendarUI();
